const CONTENT_EDITOR_SIDEBAR_TREE_KEY = "contentEditorSidebarTree";

export const getContentEditorSidebarTreeKey = (courseId) => {
  if (courseId == null || courseId === "") return CONTENT_EDITOR_SIDEBAR_TREE_KEY;
  return `${CONTENT_EDITOR_SIDEBAR_TREE_KEY}:${courseId}`;
};

const normalizeContentEditorSidebarTree = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(value).filter(
      ([key, expanded]) => typeof key === "string" && typeof expanded === "boolean"
    )
  );
};

export const readContentEditorSidebarTree = (courseId) => {
  if (typeof window === "undefined") return {};

  try {
    const raw = sessionStorage.getItem(getContentEditorSidebarTreeKey(courseId));
    if (!raw) return {};
    return normalizeContentEditorSidebarTree(JSON.parse(raw));
  } catch (_err) {
    return {};
  }
};

export const writeContentEditorSidebarTree = (courseId, value) => {
  if (typeof window === "undefined") return;

  try {
    sessionStorage.setItem(
      getContentEditorSidebarTreeKey(courseId),
      JSON.stringify(normalizeContentEditorSidebarTree(value))
    );
  } catch (_err) {
    // Ignore storage errors (private mode, quota exceeded, etc.)
  }
};
